import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon, TruckIcon, ThumbsUpIcon } from 'lucide-react';
export function AboutSection() {
  const highlights = [{
    icon: TruckIcon,
    title: 'Free Delivery & Pickup',
    desc: 'To your hotel or residence'
  }, {
    icon: ShieldCheckIcon,
    title: 'Best Rate Guarantee',
    desc: 'We beat any advertised estimate'
  }, {
    icon: CheckCircle2Icon,
    title: 'Wide Selection',
    desc: 'Scooters, wheelchairs & more'
  }, {
    icon: ThumbsUpIcon,
    title: 'Satisfaction Guaranteed',
    desc: 'Top-rated customer service'
  }];
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-22">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-23">
            <div className="flex items-center gap-3 mb-4" data-id="element-24">
              <div className="h-[2px] w-8 bg-brand-red" data-id="element-25"></div>
              <span className="text-brand-red font-bold tracking-wider text-sm uppercase" data-id="element-26">
                About Us
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-navy mb-6 leading-tight" data-id="element-27">
              WheelAround Rentals
            </h2>

            <div className="space-y-4 text-brand-charcoal/80 text-lg leading-relaxed" data-id="element-28">
              <p data-id="element-29">
                WheelAround Rentals provides electric scooters, manual
                wheelchair, Power Wheelchairs and many more mobility equipment
                within the District of Columbia Metro area (DMV) and beyond. Our
                services cover The District of Columbia, Maryland, Baltimore and
                Northern Virginia (Fairfax, Alexandria, Manassas, Falls Church,
                Arlington, and Tysons). Call us now for our nationwide scooter
                and wheelchair rental service areas.
              </p>
              <p data-id="element-30">
                Are you visiting the Nations' capital for business or pleasure?
                Great! WheelAround Rentals has your mobility needs covered. We
                will deliver the mobility equipment of your choice to a location
                of your choosing and pick up from the same location at no extra
                cost to you.
              </p>
              <p data-id="element-31">
                To assure you of our customer satisfaction guarantee, we can
                also pick up from a different location at NO ADDITIONAL COST. We
                guarantee the best rental rates in the city and we will beat any
                advertised rental estimate.
              </p>
              <p className="font-semibold text-brand-navy" data-id="element-32">
                Rent with WheelAround and put your mind at ease as we provide
                you with the quality service you deserve.
              </p>
            </div>

            <div className="mt-8" data-id="element-33">
              <a href="#products" className="inline-flex items-center text-brand-blue font-semibold hover:text-brand-navy transition-colors" data-id="element-34">
                Explore our equipment <span className="ml-2" data-id="element-35">→</span>
              </a>
            </div>
          </motion.div>

          {/* Visual Card */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-36">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-blue/10 to-brand-red/5 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-37"></div>
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-10 relative z-10" data-id="element-38">
              <h3 className="text-2xl font-bold text-brand-navy mb-8" data-id="element-39">
                Why Choose WheelAround?
              </h3>

              <div className="space-y-6" data-id="element-40">
                {highlights.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.4 + index * 0.1
              }} className="flex items-start gap-4" data-id="element-41">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-navy/5 flex items-center justify-center text-brand-blue" data-id="element-42">
                      <item.icon className="w-6 h-6" data-id="element-43" />
                    </div>
                    <div data-id="element-44">
                      <h4 className="text-lg font-bold text-brand-navy" data-id="element-45">
                        {item.title}
                      </h4>
                      <p className="text-brand-charcoal/70" data-id="element-46">{item.desc}</p>
                    </div>
                  </motion.div>)}
              </div>

              <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-47">
                <div className="flex items-center justify-between" data-id="element-48">
                  <div data-id="element-49">
                    <p className="text-sm text-brand-charcoal/60 font-medium" data-id="element-50">
                      Have questions?
                    </p>
                    <a href="tel:+18003954459" className="text-xl font-bold text-brand-red hover:text-red-700 transition-colors" data-id="element-51">
                      (800) 395-4459
                    </a>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-brand-red/10 flex items-center justify-center" data-id="element-52">
                    <span className="text-brand-red font-bold text-xl" data-id="element-53">
                      24/7
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}